import { AsnSchemaStorage } from "./schema";
export const schemaStorage = new AsnSchemaStorage();
